import React, { useEffect } from "react";
import DescargarApp from "./DescargarApp";
import { Typography } from "@mui/material";
import DescargarPDF from "./Reusables/DescargarPDF";

export default function Home(props) {
  useEffect(() => {
    //document.title = props.titulo;
  }, [props.titulo]);

  return (
    <div>
      <DescargarApp />
      <h2 id="donaalcreador">Uso de JChess Manager</h2>

      <div style={{ width: "100%", maxWidth: "640px"}}>
        <div
          style={{
            position: "relative",
            paddingBottom: "56.25%",
            height: 0,
            overflow: "hidden",
          }}
        >
          <iframe
            title="YouTube video"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
            }}
            src="https://youtube.com/embed/jaFLXa2KaX8"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      </div>

      <div>
        Mira el tutorial de Youtube, o descarga el tutorial de JChessManager en PDF
      </div>

      <DescargarPDF />

      <div>
        <div className="separator">
          <div>
            <div>
              <div>
                <div className="separator">
                  <div>
                    <h2 id="motivoanuncios">
                      ¿Porqué la aplicación tiene anuncios?
                    </h2>
                    <div>
                      La aplicación contiene anuncios porque tiene funciones que
                      requieren servicios en la nube, los servidores tienen un
                      costo según el uso (a más usuarios mayor será el costo por
                      mes de los servidores), debito a esto se trata de
                      sustentar aplicación mediante los anuncios.
                    </div>
                    <div></div>
                    <h2 id="donaalcreador">
                      ¿Cómo donar al creador de la aplicación?
                    </h2>
                    <div>
                      Puedes donar mediante <b>PayPal</b> buscando el siguiente
                      correo&nbsp;<b>jhonmoralesestrada@gmail.com</b>&nbsp;en la
                      sección de enviar. De esta forma ayudas al creador a
                      seguir dando soporte a la aplicación, y así vaya mejorando
                      la app constantemente.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <br />
      <br />
      <div>
        Puedes contactar o reportar un error mediante el siguiente
        correo:&nbsp;&nbsp;<b>jhonmoralesestrada@gmail.com</b>
      </div>
      <div></div>
    </div>
  );
}
